import React from 'react';
import ReportingMembershipsPendingCancelationsPage from '../components/ReportingMembershipsPendingCancelationsPage';

const ReportingMembershipsPendingCancelationsApp = (props) => (
  <ReportingMembershipsPendingCancelationsPage {...props} />
);

export default ReportingMembershipsPendingCancelationsApp;
